import React from "react";
import {useNotification} from "../../Notifications/NotificationsContext";

export function NotificationCount(props) {
  const { notificationData } = useNotification();

  return <>{notificationData?.totalcount}</>;
}
